// 1-导入路由模块
import Router from 'vue-router';
import Vue from 'vue';
// 2-注册路由模块
Vue.use(Router);
// 3-定义路由规则
const home = () => import ('../pages/index.vue');
const routes = [
        // 路由重定向
        {
            path: '/',
            component: home,
            meta: {
                title: '',
            },
        }
    ]
    // 4-创建路由对象
const router = new Router({
    // 引用路由规则
    routes: routes,
    // 自定义路由导航高亮选择器的名称(默认router-link-active)
    linkActiveClass: 'active',
    // mode属性是设置路由模式的, 可选值: hash(默认值, 页面访问地址带#), history(页面访问地址不带#)
    mode: 'hash',
    // 自动重置页面滚动条的位置
    scrollBehavior() {
        return {
            x: 0, // 水平方向滚动条的位置
            y: 0 // 垂直方向滚动条的位置
        }
    }
});

// 全局前置守卫
// to: 系统自动注入, 表示即将前往的页面对应的路由对象
// from: 系统自动注入, 表示即将离开的页面对应的路由对象
// next: 系统自动注入, 表示一个路由跳转方法
router.beforeEach(function(to, from, next) {
    // 当前访问的页面需要登录
    if (to.meta.requireLogin) {
        // 读取登录信息
        // const memInfo = JSON.parse(localStorage.getItem('memInfo') || '{}');
        const memInfo = localStorage.getItem('memInfo') || '{}';
        // 没有登录
        if (!memInfo.token) {
            // 自动跳转到登录页面
            next('/login');
        }
    }
    next();
    // 动态设置页面标题
    document.title = to.meta.title;
});
// 导出路由实例
export default router;